import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { PeopleCertificationTableFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/certification/_list/people/')({
  validateSearch: zodValidator(PeopleCertificationTableFilterSchema),
});
